import { CredentialsKeyEnum } from '../../../types';
export const secureCredentials = [
    CredentialsKeyEnum.ApiKey,
    CredentialsKeyEnum.ApiToken,
    CredentialsKeyEnum.Headers,
    CredentialsKeyEnum.SecretKey,
    CredentialsKeyEnum.Token,
    CredentialsKeyEnum.Password,
    CredentialsKeyEnum.ServiceAccount,
    CredentialsKeyEnum.SigningSecret,
];
//# sourceMappingURL=secure-credentials.js.map